import { useTranslation } from 'react-i18next'

// local imports
import { IFilteredPoolVehicleList } from 'types/PoolVehicleType'
import {
  ReservationButton,
  BrandModel,
  VehicleLocation,
  LocationInfos,
  StyledCard,
  CardHeaderOverlay,
  VehicleInfos,
  DescriptionWrapper,
} from './styled'

interface ComponentProps {
  vehicle: IFilteredPoolVehicleList
  openModal: (vehicle: IFilteredPoolVehicleList) => void
}

export default function PoolVehicleCard({ vehicle, openModal }: ComponentProps) {
  const { t } = useTranslation()

  /* ######### Pool Vehicle Data Destructuring ######### */
  const {
    modelOfVehicle,
    brandOfVehicle,
    description,
    gearType,
    fuelType,
    plate,
    locationToReceive,
    locationToDeliver,
    locationToVehicle: { name, districtName },
  } = vehicle || {}

  /* Variables - functions */
  const openReservationModal = () => openModal(vehicle)
  const locationName = `${name}, ${districtName}`

  return (
    <StyledCard>
      <CardHeaderOverlay />

      <div className="d-flex flex-column align-items-center flex-grow-1 px-3">
        <div className="d-flex flex-column align-items-center text-center flex-grow-1">
          <BrandModel>{`${brandOfVehicle} - ${modelOfVehicle}`}</BrandModel>
          <VehicleLocation>{locationName}</VehicleLocation>
          <VehicleInfos>
            <span>{`${gearType.name}, ${fuelType.name}`}</span>
            <div>
              <span>
                <span className="plate-title">{t('park-area-res-modal.licence-plate')}: </span> {plate}
              </span>
            </div>
          </VehicleInfos>
          <DescriptionWrapper> {description} </DescriptionWrapper>
        </div>

        <LocationInfos>
          <span className="wh-title">{t('pool-vehicle-res-modal.location-to-receive')}: </span>
          <span>{locationToReceive}</span>
        </LocationInfos>
        <LocationInfos>
          <span className="wh-title">{t('pool-vehicle-res-modal.location-to-deliver')}: </span>
          <span>{locationToDeliver}</span>
        </LocationInfos>
        <ReservationButton onClick={openReservationModal}>{t('buttons.book-reservation')}</ReservationButton>
      </div>
    </StyledCard>
  )
}
